/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import * as types from './local-gen-types';
export * from './local-gen-types';

export interface AccountRole {
    accountRoleType: AccountRoleType;
    customerName: string;
    customerNumber?: string;
}

export interface ActivationCardToken {
    cardType: CardType;
    deviceType: DeviceType;
    eikaCardId: string;
    eikaTokenId: string;
    panUniqueReference?: string;
    tokenUniqueReference?: string;
}

export interface Address {
    address: string[];
    city?: string;
    country?: string;
    postalCode?: string;
}

export interface AllowedCardActions {
    payBillFromCard: boolean;
    transferFromCard: boolean;
}

export interface AndroidDigitalWalletCard extends WalletCard {
    productId?: number;
    status: DigitalWalletTokenStatus;
    tokenUniqueReference?: string;
}

export interface AndroidWalletProvisionData {
    administrativeArea?: string;
    cardDisplayName: string;
    cardLastDigits: string;
    city?: string;
    countryCode?: string;
    networkCode: number;
    opc: string;
    phoneNumber?: string;
    postalCode?: string;
    tokenServiceProviderCode: number;
    userAddress1?: string;
    userAddress2?: string;
    userName?: string;
}

export interface AppSpendingLimit {
    daily?: types.MonetaryAmount;
    monthly?: types.MonetaryAmount;
}

export interface ApplePayCard {
    cardLast4Digits: string;
    cardVendor: CardVendor;
    customerName: string;
    eikaCardId: string;
    title: string;
}

export interface ApplePayEligibleCard extends ApplePayCard {
    imageName: string;
    tokens: ApplePayToken[];
}

export interface ApplePayEligibleCardsRequestParameters {
    localPassList: ApplePayPrimaryAccountIdentifier[];
    passes: ApplePayPrimaryAccountIdentifier[];
    remotePassList: ApplePayPrimaryAccountIdentifier[];
    watchPaired: boolean;
}

export interface ApplePayPrimaryAccountIdentifier {
    value: string;
}

export interface ApplePayToken {
    deviceType: DeviceType;
    panUniqueReference?: string;
    status: ApplePayTokenStatus;
    tokenType: ApplePayTokenType;
}

export interface Balance {
    amount: number;
    type: BalanceType;
}

export interface Bank {
    name: string;
    registrationNumber: string;
}

export interface Benchmark {
    baseCurrency: string;
    destinationAmount: types.MonetaryAmount;
    markup: number;
    markupWithAdditionalFee?: number;
    rate: number;
    rateTimestamp: Date;
    system: System;
}

export interface BillPaymentRequest {
    amount: number;
    description?: string;
    kid?: string;
    message?: string;
    payeeAccountNumber: string;
    payeeName: string;
    payerCardId: string;
    senderAccountId: string;
}

export interface BillingAddress {
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    countryCode: string;
    postalCode?: string;
    state?: string;
}

export interface BillingSummary {
    kidNumber: string;
    paymentBankAccountNumber: string;
    paymentDueDate?: Date;
    paymentDueDay: number;
}

export interface Card {
    accountId: string;
    accountNumber: string;
    accountOwner: string;
    accountType: CardAccountType;
    activation?: CardActivation;
    allowedOperations: CardAllowedOperations;
    bankRegistrationNumber: string;
    block?: CardBlock;
    created: Date;
    embossedName: string;
    embossedName2: string;
    expirationDate: types.CardExpiryDate;
    id: string;
    imagePath: string;
    market: types.Market;
    number: string;
    orderStatus: OrderCardStatus;
    owner: string;
    product: CardProduct;
    status: CardStatus;
    type: CardType;
    vendor: CardVendor;
    version: number;
}

export interface CardAllowedOperations {
    activateCard: boolean;
    delete: boolean;
    getLoyalty: boolean;
    getMyDisputes: boolean;
    getOnlineSpending: boolean;
    getPin: boolean;
    getRule: boolean;
    getSpendingLimit: boolean;
    getVirtualCard: boolean;
    hardBlock: boolean;
    migrationWeekEnd: boolean;
    migrationWeekStart: boolean;
    reorder: boolean;
    setCancellation: boolean;
    setLoyalty: boolean;
    setOnlineSpending: boolean;
    setPin: boolean;
    setRule: boolean;
    setSpendingLimit: boolean;
    setWallets: boolean;
    softBlock: boolean;
    unblock: boolean;
}

export interface CardBlock {
    code: CardBlockCode;
    date: Date;
}

export interface CardHolder {
    customerNumber: OffentligId;
    firstName: string;
    lastName: string;
    name: string;
    role: CustomerRole;
}

export interface CardOrder {
    accountNumber: string;
    accountOwnerNumber: string;
    activation?: CardActivation;
    bankNumber: string;
    cardEmbossedName: string;
    cardEmbossedName2: string;
    cardOwnerNumber: string;
    cardProduct: DebitCardProduct;
    id: string;
    newCardId?: string;
    oldCardId?: string;
    signingUrl?: string;
    type: CardOrderType;
}

export interface CardProduct {
    code: string;
    id: number;
    key: string;
    name: string;
}

export interface CardRegion {
    id: string;
    name: string;
}

export interface CardReorder {
    automatic: boolean;
    cardName?: string;
    changePin: boolean;
}

export interface CardRule {
    ecommerce: boolean;
    regions: RegionRule[];
}

export interface CardSpendingLimit {
    daily?: types.MonetaryAmount;
    monthly?: types.MonetaryAmount;
}

export interface Click2PayCardInfo {
    click2PayCardAddressStatus: Click2PayCardAddressStatus;
    eikaCardId: string;
    maskedCardNumber: MaskedCardNumber;
}

export interface Click2PayCardProcessResponse {
    eikaCardId: string;
    process: Click2PayProcess;
}

export interface Click2PayCustomer {
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
}

export interface Click2PayCustomerProfile {
    cards: Click2PayCardInfo[];
    customerProfile?: Click2PayCustomer;
}

export interface Click2PayProcess {
    errorMessage?: string;
    status: Click2PayProcessStatus;
}

export interface CompletionStage<T> {
}

export interface ConversionRequest {
    additionalFee?: number;
    additionalRateFee?: number;
    destinationCurrency: string;
    rateAt?: Date;
    sourceAmount: types.MonetaryAmount;
}

export interface ConversionResult {
    benchmarks: Benchmark[];
    destinationAmount: types.MonetaryAmount;
    destinationAmountWithFee: types.MonetaryAmount;
    rate: number;
    rateTimestamp: Date;
    rateWithFee: number;
    sourceAmount: types.MonetaryAmount;
}

export interface CreditCard {
    activated: boolean;
    allowedCardActions: AllowedCardActions;
    allowedOperations: KredittbankenCardAllowedOperations;
    cardHolder: CreditCardHolder;
    cardNumber: string;
    eikaCardId: string;
    expires: types.CardExpiryDate;
    id: string;
    imagePath?: string;
    product: CreditCardProduct;
    status: CreditCardStatus;
    userIsCardOwner: boolean;
}

export interface CreditCardAccount {
    accountId: string;
    accountNumber: string;
    accountRoles: AccountRole[];
    balances: Balance[];
    billingSummary: BillingSummary;
    cards: CreditCard[];
    creditLimit: number;
    interestsRates: InterestRates;
    productName: string;
    status: KredittbankenAccountStatus;
}

export interface CreditCardApplePayMastercardProvisioningData extends CreditCardApplePayProvisioningData {
    paymentScheme: "MASTERCARD";
}

export interface CreditCardApplePayProvisioningData {
    cardId: string;
    certificates: string[];
    nonce: string;
    paymentScheme: "VISA" | "MASTERCARD";
    signature: string;
}

export interface CreditCardApplePayProvisioningResult {
    activationData: string;
    encryptedPass: string;
    publicKey: string;
}

export interface CreditCardApplePayVisaProvisioningData extends CreditCardApplePayProvisioningData {
    paymentScheme: "VISA";
}

export interface CreditCardGooglePayMastercardProvisioningData extends CreditCardGooglePayProvisioningData {
    paymentScheme: "MASTERCARD";
}

export interface CreditCardGooglePayProvisioningData {
    cardId: string;
    deviceId: string;
    paymentScheme: "VISA" | "MASTERCARD";
    walletId: string;
}

export interface CreditCardGooglePayProvisioningResult {
    digitalizationData: string;
}

export interface CreditCardGooglePayVisaProvisioningData extends CreditCardGooglePayProvisioningData {
    appId: string;
    billingAddress: BillingAddress;
    paymentScheme: "VISA";
}

export interface CreditCardHolder {
    customerNumber: OffentligId;
    firstName: string;
    lastName: string;
    role: CustomerRole;
}

export interface CreditCardProduct {
    code: string;
    name: string;
}

export interface CreditCardReservation {
    cardHolderFirstName?: string;
    cardHolderLastName?: string;
    cardHolderRole?: CustomerRole;
    cardNumber?: string;
    description: string;
    id: string;
    postAmount: number;
    transactionDate: Date;
}

export interface CreditCardToken {
    cardId: string;
    created: Date;
    device: CreditCardTokenDevice;
    eikaCardId: string;
    expiryDate: Date;
    id: string;
    number: string;
    panReferenceId?: string;
    paymentScheme: CreditCardPaymentScheme;
    requestor: CreditCardTokenRequestor;
    status: CreditCardTokenStatus;
    uniqueReferenceId?: string;
    walletType: CreditCardWalletType;
}

export interface CreditCardTokenDevice {
    id?: string;
    type?: string;
}

export interface CreditCardTokenRequestor {
    id?: string;
    name?: string;
}

export interface CreditCardTransaction {
    cardHolderFirstName?: string;
    cardHolderLastName?: string;
    cardHolderRole?: CustomerRole;
    cardNumber?: string;
    categoryDescription?: string;
    description: string;
    groupDescription?: string;
    id: string;
    postAmount: number;
    postDate: Date;
    transactionDate: Date;
}

export interface CreditCustomer {
    address: CustomerAddress;
    customerNumber: OffentligId;
    email?: string;
    firstName?: string;
    lastName?: string;
    mobile?: string;
    sourceCustomerNumber: string;
}

export interface CreditProfile {
    allowedOperations: CreditProfileAllowedOperations;
    customer: User;
}

export interface CreditProfileAllowedOperations {
    digitalWallet: boolean;
}

export interface CurrencyDetails {
    currencyCode: string;
    currencyNumericCode: number;
    displayName: string;
    symbol: string;
}

export interface CustomerAddress {
    addressLines: string[];
    city?: string;
    countryCode?: string;
    postalCode?: string;
}

export interface CustomerAllowedOperations {
    getCustomerContactInfo: boolean;
    setCustomerContactInfo: boolean;
}

export interface CustomerCardOrder {
    accountNumber: string;
    orderedAt: Date;
}

export interface CustomerContactInfo {
    email?: string;
    mobile?: string;
}

export interface DebitAccount {
    agreementName?: string;
    allowedOperations: DebitAccountAllowedOperations;
    availableBalance?: number;
    bankRegistrationNumber: string;
    blockedAmount?: number;
    bookedBalance?: number;
    creditLine?: number;
    currency?: string;
    externalId?: string;
    id: string;
    number: string;
    owner: string;
    productId?: string;
    productName?: string;
    totalReservedAmount?: number;
}

export interface DebitAccountAllowedOperations {
    accessTransactions: boolean;
    orderCard: boolean;
    setCardPin: boolean;
}

export interface DebitCardBlockRequest {
    reason: BlockReason;
    reorder?: CardReorder;
}

export interface DebitCardOrder {
    accountNumber: string;
    accountOwnerNumber: string;
    activation?: CardActivation;
    bankNumber: string;
    cardEmbossedName: string;
    cardEmbossedName2: string;
    cardOwnerNumber: string;
    cardProduct: CardProduct;
    id: string;
    newCardId?: string;
    oldCardId?: string;
    signingUrl?: string;
    type: CardOrderType;
}

export interface DebitCardOrderRequest {
    cardId?: string;
    cardName?: string;
    cardOwner?: string;
    cardPin?: PinEncryptedMessage;
    cardProductCode?: string;
}

export interface DebitCardOrderResponse {
    needsSign: boolean;
    order?: SignOrder;
}

export interface DebitProfile {
    allowedOperations: DebitProfileAllowedOperations;
    customer: User;
}

export interface DebitProfileAllowedOperations {
    cardAutomaticOrder: boolean;
    cardAutomaticReorder: boolean;
    click2Pay: boolean;
    digitalWallet: boolean;
}

export interface DebitSpendingLimit {
    app?: AppSpendingLimit;
    card?: CardSpendingLimit;
}

export interface DeprecatedCardOrderRequest {
    accountNumber: string;
    cardName?: string;
    changePin: boolean;
    product?: DebitCardProduct;
}

export interface DigitalCard {
    imageUrl: string;
    message: string;
}

export interface DigitalWalletSignResponse {
    dynamicLinkId: DynamicLinkId;
    redirectUrl: string;
}

export interface DynamicLinkId {
    value: string;
}

export interface EligibleCardInfo {
    accountName: string;
    cardNumber: MaskedCardNumber;
    eikaCardId: string;
    imagePath: string;
}

export interface EncryptedMessage {
    audit?: string;
    data: string;
    sgw: string;
}

export interface ExchangeRateResult {
    from: string;
    rate: number;
    rateTimestamp: Date;
    to: string;
}

export interface GetPinData {
    encryptedSecretKey: string;
    sessionId: string;
}

export interface GetPinSession {
    publicKey: string;
    sessionId: string;
}

export interface HarValue<T> {
    value: T;
}

export interface InterestRates {
    effectiveInterestRate?: number;
    nominalInterestRate: number;
}

export interface KidFormat {
    length: number;
    modulus: number;
}

export interface KredittbankenCardAllowedOperations {
    block: boolean;
    canPayBill: boolean;
    canTransfer: boolean;
    getChangeLimit: boolean;
    getPin: boolean;
    getUserLimit: boolean;
    getVirtualCard: boolean;
    reorder: boolean;
    setWallets: boolean;
    unblock: boolean;
}

export interface KredittbankenViewPinSession {
    activeCards: string[];
    audit: string;
    publicKey: string;
    random: string;
    sgw: string;
}

export interface KredittbankenWalletProvisionData {
    administrativeArea?: string;
    cardDisplayName: string;
    cardLastDigits: string;
    city?: string;
    countryCode?: string;
    opc: string;
    phoneNumbers?: string[];
    postalCode?: string;
    userAddress2?: string;
    userAddressLine1?: string;
    userAddressLine2?: string;
    userAddressLine3?: string;
    userAddressLine4?: string;
    userName?: string;
}

export interface MaskedCardNumber extends ObjectType<string> {
}

export interface ObjectType<T> {
}

export interface OcrInformation {
    avtaleGiroSupported: boolean;
    kidFormats: KidFormat[];
    kidRequired: boolean;
    name?: string;
}

export interface OffentligId extends HarValue<string> {
    value: string;
}

export interface OptionalDesignResponse {
    url?: string;
}

export interface Organisation {
    address: Address;
    bankRegistrationNumber: string;
    email?: string;
    mobile?: string;
    name: string;
    number: string;
}

export interface PaymentResponse {
    dynamicLinkId: DynamicLinkId;
    redirectUrl: string;
}

export interface PinEncryptedMessage {
    audit?: string;
    data: string;
    sgw: string;
}

export interface RegionRule {
    enabled: boolean;
    region: CardRegion;
}

export interface Session {
    bank?: Bank;
    channel: string;
    creditProfile?: CreditProfile;
    customerIdRedirectUrl: string;
    customerIdUrl: string;
    debitProfile?: DebitProfile;
    fraudRisk: types.FraudRiskLevel;
    highAssurance: boolean;
    mobileBank: boolean;
    toggles: { [P in Toggle]?: boolean };
    user?: SessionUser;
}

export interface SessionUser {
    ageGroup: AgeGroup;
    birthDate: Date;
    firstName: string;
    lastName: string;
    userId: string;
}

export interface SetPinResult {
    audit?: string;
}

export interface SetPinSession {
    audit: string;
    publicKey: string;
    random: string;
    sgw: string;
}

export interface SignOrder {
    status: DebitCardOrderStatus;
    url: string;
}

export interface SimplePage<T> {
    elements: T[];
    hasNextPage: boolean;
    page: number;
}

export interface TransferMoneyRequest {
    amount: number;
    recipientAccountNumber: string;
    senderAccountId: string;
    senderCardId: string;
}

export interface User {
    address: Address;
    bankRegistrationNumber: string;
    birthDate: Date;
    contact: CustomerContactInfo;
    customerAllowedOperations: CustomerAllowedOperations;
    firstName: string;
    lastName: string;
    number: string;
}

export interface ViewPinSession {
    activeCard: string;
    audit: string;
    publicKey: string;
    random: string;
    sgw: string;
}

export interface VirtualCard {
    imageUrl: string;
    message: string;
}

export interface WalletCard {
    eikaCardId: string;
}

export interface WalletCreditCard {
    accountId: string;
    accountNumber: string;
    cardHolder: CardHolder;
    cardStatus: CreditCardStatus;
    eikaCardId: string;
    id: string;
    number: string;
    product: KredittbankenCardProduct;
    status: WalletCreditCardStatus;
    tokens: CreditCardToken[];
    walletType: CreditCardWalletType;
}

export enum AccountRoleType {
    DEBTOR = "DEBTOR",
    CO_DEBTOR = "CO_DEBTOR",
    GUARANTOR = "GUARANTOR",
    UNKNOWN = "UNKNOWN",
}

export enum AgeGroup {
    ADULT = "ADULT",
    TEENAGER = "TEENAGER",
    CHILD = "CHILD",
    UNKNOWN = "UNKNOWN",
}

export enum AndroidDigitalWalletType {
    GOOGLE_PAY = "GOOGLE_PAY",
    SAMSUNG_PAY = "SAMSUNG_PAY",
}

export enum ApplePayTokenStatus {
    ELIGIBLE = "ELIGIBLE",
    PENDING_ACTIVATION = "PENDING_ACTIVATION",
    ACTIVE = "ACTIVE",
    UNKNOWN = "UNKNOWN",
}

export enum ApplePayTokenType {
    LOCAL = "LOCAL",
    REMOTE = "REMOTE",
}

export enum BalanceType {
    INTERIM_BOOKED = "INTERIM_BOOKED",
    AVAILABLE = "AVAILABLE",
    RESERVED = "RESERVED",
    INITIAL_PRINCIPAL = "INITIAL_PRINCIPAL",
    REPAID_AMOUNT = "REPAID_AMOUNT",
    EXPECTED = "EXPECTED",
    UNKNOWN = "UNKNOWN",
}

export enum BlockReason {
    SOFT_BLOCK = "SOFT_BLOCK",
    LOST = "LOST",
    STOLEN = "STOLEN",
    DAMAGED = "DAMAGED",
}

export enum CardAccountType {
    BILLING = "BILLING",
    SUPPLEMENTARY = "SUPPLEMENTARY",
    DEBIT = "DEBIT",
}

export enum CardActivation {
    ACTIVE = "ACTIVE",
    PARTLY_ACTIVATED = "PARTLY_ACTIVATED",
    PARTLY_ACTIVATED_TOKENIZATION_ONLY = "PARTLY_ACTIVATED_TOKENIZATION_ONLY",
    MUST_ACTIVATE_IN_ATM = "MUST_ACTIVATE_IN_ATM",
    NOT_ACTIVATED = "NOT_ACTIVATED",
    UNKNOWN = "UNKNOWN",
}

export enum CardBlockCode {
    SOFT_BLOCK = "SOFT_BLOCK",
    UNAUTHORIZED_USE = "UNAUTHORIZED_USE",
    LOST_CARD = "LOST_CARD",
    STOLEN_CARD = "STOLEN_CARD",
    WARM_CARD = "WARM_CARD",
    ILLEGAL = "ILLEGAL",
    UNKNOWN = "UNKNOWN",
}

export enum CardOrderType {
    MANUAL_ORDER = "MANUAL_ORDER",
    MANUAL_REORDER = "MANUAL_REORDER",
    AUTOMATIC_ORDER = "AUTOMATIC_ORDER",
    AUTOMATIC_REORDER = "AUTOMATIC_REORDER",
    UNKNOWN = "UNKNOWN",
}

export enum CardOwnership {
    OWN = "OWN",
    RELATED = "RELATED",
}

export enum CardStatus {
    OK = "OK",
    BLOCKED = "BLOCKED",
    DELETED = "DELETED",
    NOT_ACTIVATED = "NOT_ACTIVATED",
    UNKNOWN = "UNKNOWN",
}

export enum CardType {
    CREDIT = "CREDIT",
    DEBIT = "DEBIT",
}

export enum CardVendor {
    VISA = "VISA",
    MASTERCARD = "MASTERCARD",
}

export enum Click2PayCardAddressStatus {
    CORRECT = "CORRECT",
    DIFFER = "DIFFER",
}

export enum Click2PayCardOperationType {
    CARD_ADD = "CARD_ADD",
    CARD_ADDRESS_UPDATE = "CARD_ADDRESS_UPDATE",
    CARD_REMOVE = "CARD_REMOVE",
}

export enum Click2PayProcessStatus {
    PENDING = "PENDING",
    FAILED = "FAILED",
    SUCCESS = "SUCCESS",
    UNKNOWN = "UNKNOWN",
}

export enum Click2PayProfileOperationType {
    PROFILE_CREATE = "PROFILE_CREATE",
    PROFILE_EMAIL_UPDATE = "PROFILE_EMAIL_UPDATE",
    PROFILE_REMOVE = "PROFILE_REMOVE",
}

export enum CreditCardPaymentScheme {
    VISA = "VISA",
    MASTERCARD = "MASTERCARD",
    UNKNOWN = "UNKNOWN",
}

export enum CreditCardStatus {
    NORMAL = "NORMAL",
    TEMPORARY_BLOCKED = "TEMPORARY_BLOCKED",
    BLOCKED = "BLOCKED",
    CLOSED = "CLOSED",
    UNKNOWN = "UNKNOWN",
}

export enum CreditCardTokenStatus {
    ACTIVE = "ACTIVE",
    SUSPENDED = "SUSPENDED",
    DEACTIVATED = "DEACTIVATED",
    EXPIRED = "EXPIRED",
    INACTIVE = "INACTIVE",
    UNKNOWN = "UNKNOWN",
}

export enum CreditCardWalletType {
    GOOGLE_PAY = "GOOGLE_PAY",
    APPLE_PAY = "APPLE_PAY",
    SAMSUNG_PAY = "SAMSUNG_PAY",
    GARMIN_PAY = "GARMIN_PAY",
    UNKNOWN = "UNKNOWN",
}

export enum CustomerRole {
    ACCOUNT_OWNER = "ACCOUNT_OWNER",
    SUPPLEMENTARY_CARDHOLDER = "SUPPLEMENTARY_CARDHOLDER",
    CO_OWNER = "CO_OWNER",
    GUARANTOR = "GUARANTOR",
    UNKNOWN = "UNKNOWN",
}

export enum DebitCardOrderStatus {
    ACTIVE = "ACTIVE",
    SIGNED = "SIGNED",
    FAILED = "FAILED",
}

export enum DebitCardProduct {
}

export enum DeviceType {
    MOBILE_PHONE = "MOBILE_PHONE",
    TABLET = "TABLET",
    WATCH = "WATCH",
    MOBILEPHONE_OR_TABLET = "MOBILEPHONE_OR_TABLET",
    UNKNOWN = "UNKNOWN",
}

export enum DigitalWalletTokenStatus {
    ELIGIBLE = "ELIGIBLE",
    PENDING_ACTIVATION = "PENDING_ACTIVATION",
    ACTIVE = "ACTIVE",
    UNKNOWN = "UNKNOWN",
}

export enum KredittbankenAccountStatus {
    NORMAL = "NORMAL",
    BLOCKED = "BLOCKED",
    CLOSED = "CLOSED",
    UNKNOWN = "UNKNOWN",
}

export enum KredittbankenCardProduct {
    KREDITTBANKEN_VISA = "KREDITTBANKEN_VISA",
    EIKA_KREDITTKORT = "EIKA_KREDITTKORT",
    EIKA_ANSATT = "EIKA_ANSATT",
    UNKNOWN = "UNKNOWN",
}

export enum OrderCardStatus {
    ORDERED_NOT_PRODUCED = "ORDERED_NOT_PRODUCED",
    ORDERED = "ORDERED",
    SENT_TO_PRODUCTION = "SENT_TO_PRODUCTION",
    PRODUCTION_STARTED = "PRODUCTION_STARTED",
    SENT_TO_CUSTOMER = "SENT_TO_CUSTOMER",
    PRODUCED = "PRODUCED",
    UNKNOWN = "UNKNOWN",
}

export enum System {
    ECB = "ECB",
    VISA = "VISA",
}

export enum Toggle {
    KREDITTBANK_KREDITTKORT_BETJENING_WEB = "KREDITTBANK_KREDITTKORT_BETJENING_WEB",
    NEW_FEATURE = "NEW_FEATURE",
    AUTOMATIC_DEBIT_CARD_REORDER = "AUTOMATIC_DEBIT_CARD_REORDER",
    SAMSUNG_PAY_PUSH_PROVISIONING = "SAMSUNG_PAY_PUSH_PROVISIONING",
    CLICK2PAY = "CLICK2PAY",
    KREDITTBANKEN_PAY = "KREDITTBANKEN_PAY",
    VIPPS = "VIPPS",
}

export enum TokenProvider {
    APPLEPAY = "APPLEPAY",
    GOOGLEPAY = "GOOGLEPAY",
    SAMSUNGPAY = "SAMSUNGPAY",
    VISACLICK2PAY = "VISACLICK2PAY",
    ECOM_COF = "ECOM_COF",
    FIDESMO = "FIDESMO",
    FITBITPAY = "FITBITPAY",
    GARMINPAY = "GARMINPAY",
    UNKNOWN = "UNKNOWN",
}

export enum WalletCreditCardStatus {
    NOT_ELIGIBLE = "NOT_ELIGIBLE",
    ELIGIBLE = "ELIGIBLE",
    ENROLLED = "ENROLLED",
    UNKNOWN = "UNKNOWN",
}
